import ActivePoints from "./ActivePoints"

export default ActivePoints
